module.exports = __webpack_public_path__ + "static/media/Micro-deposit-grey-menu-icon.0d001b87.png";